import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentLayoutClientComponent } from './content-layout-client.component';
import { GetApplymentSettingsService } from 'src/app/core/services/client-general-settings/applyment/get-applyment-settings.service';
import { GetApplymentService } from '@app/services/client-general-settings/applyment/get-applyment.service';


const routes: Routes = [
  {
    path: '',
    component: ContentLayoutClientComponent,
    pathMatch: 'prefix',
    resolve: {
      applymentSettings: GetApplymentSettingsService,
    },
    children: [
      {
        path: '',
        loadComponent: () =>
        import('@modules/client/selective-process-page/selective-process-page.component').then(m => m.SelectiveProcessPageComponent),
        resolve: {
          applymentData: GetApplymentService,
        }
      },
      {
        path: 'login',
        loadChildren: () =>
        import('@modules/client/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'passo',
        loadChildren: () =>
        import('@modules/client/registration-steps/registration-steps.module').then(m => m.RegistrationStepsModule)
      },
      {
        path: 'processo',
        loadChildren: () =>
        import('@modules/client/selective-process-access/selective-process-access.module').then(m => m.SelectiveProcessAccessModule)
      },
      {
        path: 'inscricao',
        loadChildren: () =>
        import('@modules/client/applyment-access/applyment-access.module').then(m => m.ApplymentAccessModule)
      },
      {
        path: 'portal-inscrito',
        loadChildren: () =>
        import('@modules/client/registration-portal/registration-portal.module').then(m => m.RegistrationPortalModule)
      },
      {
        path: 'feedback',
        loadChildren: () =>
        import('@modules/client/feedbacks/feedbacks.module').then(m => m.FeedbacksModule)
      },
      {
        path: 'processo/:process_id/pagina',
        loadChildren: () =>
        import('@modules/client/page/page.module').then(m => m.PageModule)
      }
    ],
    runGuardsAndResolvers: 'always'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [],
  declarations: [],
})
export class ContentLayoutClientRoutingModule {
}
